<template>
  <v-card
    class="text-left"
    color="white"
  >
    <v-img
      class="white--text"
      height="200px"
      :src="voice.src"
    >
    </v-img>

    <v-card-title
      class="d-block fz18"
      v-html="voice.title"/>

    <v-card-text>
      <p class="text-truncate textBlack--text fz15" v-html="voice.text"/>
      <div class="d-flex">
        <v-img
          class="mr-2"
          width="20"
          max-width="20"
          :src="require('@/assets/images/icon-pin.svg')"></v-img>
        <span> {{ voice.location }}</span>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-dialog v-model="dialog" max-width="290">
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-auto font-weight-bold fz18"
            color="textBlack"
            text
            v-on="on"
          >
            Read more
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline" v-html="voice.title"/>
          <v-card-text v-html="voice.text"/>
          <v-card-actions>
            <v-btn color="green darken-1" text @click="dialog = !dialog">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    voice: {
      type: Object,
      required: true,
    }
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
  },
};
</script>

<style lang="stylus" scoped>
</style>